<template>
  <div>
    <wc-page-title title='Work Order List'>
      <template v-slot:rightSide>
        <v-btn class='mr-2' depressed height='35px' width='80px' :color="showAttempted ? 'orange' : ''" @click='showAttempted = !showAttempted'>
          <div class='mt-n1'>
            <v-icon class='mr-2' small>{{ showAttempted ? 'mdi-close' : 'mdi-check' }}</v-icon>
            <span class='mb-n1' style='font-size: 10px; letter-spacing: 0.8px;'>{{ showAttempted ? 'Hide' : 'Show' }}</span>
            <div style='font-size: 10px; letter-spacing: 0.8px;'>Attempted</div>
          </div>
        </v-btn>
        <v-btn depressed height='35px' width='80px' :color="showCompleted ? 'success' : ''" @click='showCompleted = !showCompleted'>
          <div class='mt-n1'>
            <v-icon class='mr-2' small>{{ showCompleted ? 'mdi-close' : 'mdi-check' }}</v-icon>
            <span class='mb-n1' style='font-size: 10px; letter-spacing: 0.8px;'>{{ showCompleted ? 'Hide' : 'Show' }}</span>
            <div style='font-size: 10px; letter-spacing: 0.8px;'>Completed</div>
          </div>
        </v-btn>
      </template>
    </wc-page-title>
    <v-container class='pt-0'>

      <v-row v-if='anyQuickpaysNotComplete'>
        <v-col cols='12' md='4' class='text-center'>
          <v-icon color='red' left>mdi-timer-outline</v-icon>
          <span class='font-weight-bold'>
            Quickpay Customer<br>
            must be done by 9:00am
          </span><br>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols='12' md='4'>
          <wc-loading line v-if='isLoading'></wc-loading>
          <wo-card
            v-for='w in filteredWOs'
            :key='w.id'
            :wo='w'
            :woType='getWOType(w)'
            @woComplete='woComplete'
          ></wo-card>
        </v-col>
      </v-row>

<!--         <v-snackbar top color='error' elevation='20' v-model="snackbar" timeout='-1'>
          {{ snackbarText }}
          <template v-slot:action="{ attrs }">
            <v-btn outlined v-bind="attrs" @click="reloadPage">
              <v-icon class='pr-1'>mdi-reload-alert</v-icon>
              Reload Page
            </v-btn>
          </template>
        </v-snackbar> -->

    </v-container>
  </div>
</template>

<script>
import scheduleAPI from '@/modules/schedule/api/schedule'
import miscServices from '@/services/misc'
import WOCard from './WOCard'
import _ from 'lodash'

export default {
  name: 'field-route',
  data: () => ({
    isLoading: false,
    showCompleted: false,
    showAttempted: false,
    route: null,
    snackbar: false,
    snackbarText: 'The office has updated your route',
    tab: null
  }),
  computed: {
    filteredWOs () {
      if (this.route) {
        if (this.showCompleted && this.showAttempted) {
          return this.route.wos
        } else if (this.showCompleted && !this.showAttempted) {
          return _.filter(this.route.wos, w => { return w.is_attempted === false } )
        } else if (!this.showCompleted && this.showAttempted) {
          return _.filter(this.route.wos, w => { return  w.is_complete === false } )
        } else {
          return _.filter(this.route.wos, { 'is_attempted': this.showAttempted, 'is_complete': this.showCompleted } )
        }
      }
      return []
    },
    // as of 2021-02-10, the thin wo included within the route.wos array does not have quickpay info.
    anyQuickpaysNotComplete () {
      if (this.route) {
        return _.some(this.route.wos, {'project_is_quickpay': true, 'is_complete': false})
      }
      return false
    },
    allWOsComplete () {
      return _.every(this.route.wos, w => w.is_complete === true || w.is_attempted === true)
    },
    woTypes () {
      return _.orderBy(this.$store.state.misc.woTypes, 'name')
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.getRoute()
      this.isLoading = false
    },
    async getRoute () {
      this.route = await scheduleAPI.getRoute(this.$route.params.id)
    },
    woComplete (wo) {
      // api update call happens within WoCard component
      miscServices.replaceObject(this.route.wos, wo)
    },
    getWOType (wo) {
      return _.find(this.woTypes, function(w) { return w.id === wo.wo_type })
    },
  },
  components: {
    'wo-card': WOCard
  }
}
</script>
